import TaskEfficiencyIndicator from './TaskEfficiencyIndicator';

export default TaskEfficiencyIndicator;
